import { getDonorsRestricted } from 'api/DonorsApi';
import { AccordionBodyItem } from 'component/Accordion';
import { SelectComponent } from 'component/Select';
import React, { useEffect, useState } from 'react';
import { useUser } from 'routes/UserContext';
import { axiosWrapper } from 'utils/Helper';

export const Donor = (props) => {
  const [options, setOptions] = useState([]);
  const { user } = useUser();
  const formValue = props.formData?.info?.general?.donor ?? props.formData?.donor;

  useEffect(() => {
    axiosWrapper(() => {
      getDonorsRestricted()
        .then((res) => {
          const list = Array.isArray(res?.data) ? res.data : [];
          setOptions(
            list.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }, []);

  useEffect(() => {
    if (formValue != null || !user?.default_donor) return;
    const defaultId = user.default_donor?.id ?? user.default_donor;
    if (defaultId && props.setFormData) {
      props.setFormData((prev) => {
        const prevInfo = prev?.info || {};
        const prevGeneral = prevInfo.general || {};
        return {
          ...prev,
          info: { ...prevInfo, general: { ...prevGeneral, donor: defaultId } },
          donor: defaultId,
        };
      });
    }
  }, [user?.default_donor, props.setFormData]);

  const handleDonor = (value) => {
    const id = value?.value ?? value;
    props.setFormData((prevFormData) => ({
      ...prevFormData,
      info: {
        ...prevFormData?.info,
        general: {
          ...prevFormData?.info?.general,
          donor: id,
        },
      },
      donor: id,
    }));
  };

  const valueId = formValue?.value ?? formValue;

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>1.6</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Донор"
      titleEN="Donor"
      className={props.errors?.includes?.('donor') ? 'error error-text' : ''}
      children={(
        <div className="flex-group no-wrap">
          <SelectComponent
            isMulti={false}
            value={valueId ? {
              value: options.find((obj) => obj.value === valueId)?.value ?? valueId,
              label: options.find((obj) => obj.value === valueId)?.label ?? '',
            } : null}
            handleSelect={handleDonor}
            options={options}
            placeholder="Select"
            isSearchable
            noOptionsMessage={() => 'No donors for this organization'}
          />
        </div>
      )}
    />
  );
};
